import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 32,
		cy: 32,
		r: 32,
		fill: "#008500"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M42.6654 24L27.9987 38.6667L21.332 32",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckCircleFilled;
